








import * as $ from 'jquery'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class SelectionDropdown extends Vue {

	@Prop({ default: 'activate', type: [Function, String] })
	readonly action!: SelectionDropdownAction | ((text: string, value: string, element: JQuery) => void)

	@Prop()
	readonly allowAdditions?: boolean

	@Prop({ default: true })
	readonly hideAdditions!: boolean

	@Prop({ default: true })
	readonly forceSelection!: boolean

	@Prop()
	readonly fullTextSearch?: boolean

	@Prop({ default: 'both' })
	readonly match!: SelectionDropdownMatchType

	@Prop({ default: 1 })
	readonly minCharacters!: number

	@Prop()
	readonly multiple?: boolean

	@Prop({ default: true })
	readonly useLabels!: boolean

	@Prop([Array, String])
	readonly value!: string | string[]

	mounted(): void {

		$(this.$el).dropdown({
			action: this.action,
			allowAdditions: this.allowAdditions,
			forceSelection: this.forceSelection,
			fullTextSearch: this.fullTextSearch,
			hideAdditions: this.hideAdditions,
			match: this.match,
			minCharacters: this.minCharacters,
			onAdd: (addedValue, addedText, $addedChoice) => this.$emit('add', addedValue, addedText, $addedChoice),
			useLabels: this.useLabels,
		})

		this.setValue()
	}

	onInputChanged(evt: Event): void {

		const el = evt.target as HTMLInputElement
		const { value } = el

		if (this.multiple) {
			this.$emit('input', value ? value.split(',') : [])
		} else {
			this.$emit('input', value)
		}
	}

	@Watch('value')
	onWatchValue(newValue: SelectionDropdown['value'], oldValue: SelectionDropdown['value']): void {

		if (newValue === oldValue) {
			return
		}

		if (Array.isArray(newValue) &&
			Array.isArray(oldValue) &&
			newValue.length === oldValue.length &&
			newValue.every((value, index) => value === oldValue[index])) {
			return
		}

		this.setValue()
	}

	private setValue(): void {

		if (this.multiple) {
			const values = Array.isArray(this.value) ? this.value : [this.value]
			$(this.$el).dropdown('set exactly', values)
		} else {
			const value = Array.isArray(this.value) ? this.value[0] : this.value
			$(this.$el).dropdown('set selected', value)
		}
	}

}

export type SelectionDropdownAction
	= 'activate'
	| 'combo'
	| 'hide'
	| 'select'

export type SelectionDropdownMatchType
	= 'both'
	| 'text'
	| 'value'

